import { render, staticRenderFns } from "./Custom-Card.vue?vue&type=template&id=2c0018f1&"
import script from "./Custom-Card.vue?vue&type=script&lang=js&"
export * from "./Custom-Card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0018f1')) {
      api.createRecord('2c0018f1', component.options)
    } else {
      api.reload('2c0018f1', component.options)
    }
    module.hot.accept("./Custom-Card.vue?vue&type=template&id=2c0018f1&", function () {
      api.rerender('2c0018f1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Custom-Card.vue"
export default component.exports